/* @flow */

import { getBraindateId } from '@braindate/domain/lib/braindate/util';
import { getExpressionOfGratitudeId } from '@braindate/domain/lib/expressionOfGratitude/util/expressionOfGratitudeGetters';
import {
  notificationBundleTypeExpressionPost,
  notificationInfoLevel,
  notificationModalType,
} from 'src/shared/app/notification/constant/notificationConstants';
import {
  homeRoute,
  peopleFeedRoute,
} from 'src/shared/app/base/route/setting/routeSettings';

// Components
import ExpressionOfGratitudeRecipientModal from 'src/shared/app/expression-of-gratitude/component/modal/ExpressionOfGratitudeRecipientModal';

// Types
import type { Braindate } from '@braindate/domain/lib/braindate/type';
import type { ExpressionOfGratitude } from '@braindate/domain/lib/expressionOfGratitude/type';
import type { Notification as NotificationType } from 'src/shared/app/notification/type/notificationTypes';
import { NOTIFICATION_COMPONENT_KEYS } from 'src/shared/app/notification/constant/notificationComponentsMap';

export const getExpressionReceiveNotificationId = (
  expressionOfGratitude: ExpressionOfGratitude,
): string =>
  `expression-received-${getExpressionOfGratitudeId(expressionOfGratitude)}`;

export function buildExpressionOfGratitudePostBraindateNotification(
  braindate: Braindate,
): NotificationType<> {
  return {
    id: `expression-post-braindate-${getBraindateId(braindate)}`,
    level: notificationInfoLevel,
    type: notificationModalType,
    componentKey: NOTIFICATION_COMPONENT_KEYS.EXPRESSION_RECEIVED,
    data: { braindate },
    bundleType: notificationBundleTypeExpressionPost,
  };
}

export function buildExpressionOfGratitudeRecipientNotification(
  expressionOfGratitude: ExpressionOfGratitude,
): NotificationType<> {
  return {
    id: getExpressionReceiveNotificationId(expressionOfGratitude),
    level: notificationInfoLevel,
    type: notificationModalType,
    componentClass: ExpressionOfGratitudeRecipientModal,
    data: { expressionOfGratitude },
    include: [homeRoute, peopleFeedRoute],
  };
}
